import { Injectable, computed, effect, inject, signal } from '@angular/core'
import { toObservable, toSignal } from '@angular/core/rxjs-interop'
import { EMPTY, map, of, shareReplay, switchMap } from 'rxjs'
import { AppTrpcServiceInjectionToken } from './app-trpc.service.js'
import { AppContext } from '../app-context.js'
import { UserTaskTokenDetails } from '@lg/shared'
import { jsonMapper } from '@lg/shared'

@Injectable({
	providedIn: 'root',
})
export class ProcessService {
	tokenId = signal<string | null>(null)
	taskDetails$ = toObservable(this.tokenId).pipe(
		switchMap((tokenId) => {
			if (!tokenId) return of(undefined)
			const trpc = AppContext.injector.get(AppTrpcServiceInjectionToken)
			return trpc.queryAsObservable((c) =>
				c.process.getTaskDetailsByIds
					.query({
						tokenIds: [tokenId],
						includeAssignments: true,
					})
					.then((r: any) => r[0]),
			)
		}),
		map((taskDetails) =>
			jsonMapper.deserializeFromObject(taskDetails!, UserTaskTokenDetails),
		),
		shareReplay(1),
	)
	taskDetails = toSignal(this.taskDetails$)
	isProcessTask = computed(() => !!this.tokenId())
	isUnassignedTask = computed(
		() => !!this.taskDetails() && !this.taskDetails()!.assignedToUserId,
	)
	isAssignedTask = computed(
		() => !!this.taskDetails() && !!this.taskDetails()!.assignedToUserId,
	)
}
